import {
  LIST_FILTERS,
  LIST_REGIONS,
  UPDATE_SELECTED_FILTERS,
  SET_CURRENT_SEARCHABLE,
  TOGGLE_FILTER_SUBMIT,
  LIST_PROGRAMMES,
  UPDATE_PROGRAMME_FILTERS,
  GET_REGIONS,
  SET_RESULT_HASH,
  GET_PARTNER_COVERAGE_BY_REGION
} from 'store/actions/filters'
import typeToReducer from 'type-to-reducer'

import produce from 'immer'

export const initialState = {
  availableFilters: [],
  regions: null,
  filteredRegionsList: [],
  filteredPartnerCoverage: {},
  programmes: null,
  currentSearchable: null,
  programmeFilters: {
    types: null,
    periods: null
  },
  selectedFilters: {
    projects: {
      projects: {
        status: null,
        only_projects_with_documents: false,
        project_details: {
          start: [],
          without_start: false,
          end: [],
          without_end: false
        },
        project_budget: {
          range: [],
          without_budget: false
        },
        themes: {
          list: [],
          type: 'or'
        },
        macro_regional_strategies: [],
        only_infrastructure_financed: false
      },
      programmes: {
        type: [],
        period: [],
        available: []
      },
      partners: {
        status: [],
        nuts_lead: [],
        nuts_partner: [],
        nuts_search_type: 'both',
        selectedAreas: {}
      },
      specific_objectives: {
        thematic_objectives: [],
        thematic_priorities: []
      },
      search: {
        list: [],
        type: null,
        fields: [],
        rawSearchString: ''
      },
      documents: {
        document_lang: [],
        languages: [],
        types: [],
        search: ''
      },
      project_lang: [],
      project_desc_lang: [],
      languages: [],
      translation_languages: [],
      thematic_objectives_eni: [],
      location: null
    },
    programmes: {
      programmes: {
        type: [],
        period: [],
        nuts: []
      },
      specific_objectives: {
        thematic_objectives: [],
        thematic_priorities: [],
        common_output_indicators: []
      },
      search: {
        list: [],
        type: null,
        rawSearchString: ''
      },
      thematic_objectives_eni: [],
      thematic_objectives_eni_common_output_indicators: []
    },
    partners: {
      projects: {
        themes: {
          list: [],
          type: 'or'
        }
      },
      programmes: {
        type: [],
        available: [],
        period: []
      },
      partners: {
        type: [],
        status: [],
        countries: [],
        nuts: []
      },
      specific_objectives: {
        thematic_objectives: [],
        thematic_priorities: []
      },
      search: {
        list: [],
        type: null,
        rawSearchString: ''
      },
      thematic_objectives_eni: []
    },
    countries_and_regions: {
      detailed_search: true,
      search: {
        list: [],
        type: null,
        fields: [],
        rawSearchString: ''
      },
      options: {
        regions: [],
        nutsLevel: 0
      },
      programmes: {
        nuts: []
      }
    }
  },
  submitEnabled: true,
  isPending: true,
  isRegionsPending: false,
  isFilteredRegionsPending: false,
  isProgrammesPending: false,
  error: {
    messages: []
  },
  resultHash: ''
}

export default typeToReducer(
  {
    [LIST_FILTERS]: {
      PENDING: state =>
        produce(state, draft => {
          draft.isPending = true
        }),
      REJECTED: (state, { payload: { response } }) =>
        produce(state, draft => {
          draft.isPending = false
          draft.error = response
        }),
      FULFILLED: (state, { payload }) =>
        produce(state, draft => {
          draft.availableFilters = payload
          draft.isPending = false
        })
    },
    [LIST_REGIONS]: {
      PENDING: state =>
        produce(state, draft => {
          draft.isRegionsPending = true
        }),
      REJECTED: (state, { payload: { response } }) =>
        produce(state, draft => {
          draft.isRegionsPending = false
          draft.error = response
        }),
      FULFILLED: (state, { payload }) =>
        produce(state, draft => {
          draft.regions = payload
          draft.isRegionsPending = false
        })
    },
    [GET_REGIONS]: {
      PENDING: state =>
        produce(state, draft => {
          draft.isFilteredRegionsPending = true
        }),
      REJECTED: (state, { payload: { response } }) =>
        produce(state, draft => {
          draft.isFilteredRegionsPending = false
          draft.error = response
        }),
      FULFILLED: (state, { payload }) =>
        produce(state, draft => {
          draft.filteredRegionsList = payload
          draft.isFilteredRegionsPending = false
        })
    },
    [GET_PARTNER_COVERAGE_BY_REGION]: {
      PENDING: state =>
        produce(state, draft => {
          draft.isPartnerFilterPending = true
        }),
      REJECTED: (state, { payload: { response } }) =>
        produce(state, draft => {
          draft.isPartnerFilterPending = false
          draft.error = response
        }),
      FULFILLED: (state, { payload }) =>
        produce(state, draft => {
          draft.filteredPartnerCoverage = payload
          draft.isPartnerFilterPending = false
        })
    },
    [LIST_PROGRAMMES]: {
      PENDING: state =>
        produce(state, draft => {
          draft.isProgrammesPending = true
        }),
      REJECTED: (state, { payload: { response } }) =>
        produce(state, draft => {
          draft.isProgrammesPending = false
          draft.error = response
        }),
      FULFILLED: (state, { payload }) =>
        produce(state, draft => {
          draft.programmes = payload
          draft.isProgrammesPending = false
        })
    },
    [SET_CURRENT_SEARCHABLE]: (state, { payload }) =>
      produce(state, draft => {
        draft.currentSearchable = payload
      }),
    [UPDATE_SELECTED_FILTERS]: (state, { payload }) => {
      const { filterType, filterId, filterValue, isHigherLevelFilter, wholeFilterObject } = payload
      if (wholeFilterObject) {
        try {
          return produce(state, draft => {
            draft.resultHash = ''
            draft.selectedFilters[state.currentSearchable] = wholeFilterObject
          })
        } catch {
          return produce(state, draft => {
            draft.resultHash = ''
            draft.selectedFilters[state.currentSearchable] = state.selectedFilters
          })
        }
      }
      if (isHigherLevelFilter) {
        return produce(state, draft => {
          draft.resultHash = ''
          draft.selectedFilters[state.currentSearchable][filterId] = filterValue
        })
      }
      return produce(state, draft => {
        draft.resultHash = ''
        draft.selectedFilters[state.currentSearchable][filterType][filterId] = filterValue
      })
    },
    [UPDATE_PROGRAMME_FILTERS]: (state, { payload }) => {
      const { filterId, filterValue } = payload
      return produce(state, draft => {
        draft.programmeFilters[filterId] = filterValue
      })
    },
    [TOGGLE_FILTER_SUBMIT]: (state, { payload }) => {
      const { submitEnabled } = payload
      return produce(state, draft => {
        draft.submitEnabled = submitEnabled
      })
    },
    [SET_RESULT_HASH]: (state, { payload }) =>
      produce(state, draft => {
        draft.resultHash = payload
      })
  },
  initialState
)
